

<body class="mat-app-background ">
  <ng-template #bloqueoMetaApi>
    <mat-card class="alert-card m-3">
      <mat-card-content>
        <p>
          <mat-icon>block</mat-icon>
          Esta pantalla no está disponible para cuentas MetaTrader 5. Consulte posiciones y órdenes desde el módulo Broker.
        </p>
        <button mat-stroked-button (click)="close()">Cerrar</button>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <div *ngIf="!bloqueadoMetaApi; else bloqueoMetaApi" class="container-fluid m-0 p-0 col-panel-wrapper" >

  <mat-card *ngIf="idCarteraBroker! === '0'" class="alert-card">
  <mat-card-content>
    <p>
      <mat-icon>warning</mat-icon>
      Debe seleccionar una cartera en el modulo Broker.
    </p>
  </mat-card-content>
</mat-card>

  <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
       [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <p class="col-panel-group">Posiciones</p>
      <div class="col-panel-option" *ngFor="let col of columnas.posiciones">
        <mat-checkbox [checked]="col.visible" (change)="toggleColumna(col)" [color]="'primary'">{{col.nombre}}</mat-checkbox>
      </div>
      <mat-divider style="margin: 6px 0;"></mat-divider>
      <p class="col-panel-group">Órdenes</p>
      <div class="col-panel-option" *ngFor="let col of columnas.ordenes">
        <mat-checkbox [checked]="col.visible" (change)="toggleColumna(col)" [color]="'primary'">{{col.nombre}}</mat-checkbox>
      </div>
    </div>
  </div>
      <h5 class="sc-title">
        <span class="cartera-title-tag">
          <span class="cartera-title-tag__dot"></span>
          POSICIONES: {{optimaWallet.nombre}}
        </span>
        <span class="broker-tag">{{ tipoBroker === 'METAAPI' ? 'MetaTrader 5' : 'Interactive Brokers' }}</span>
        <span class="conteo-tag" matTooltip="Posiciones abiertas">{{ posiciones.length }}</span>
        <div style="display: flex; gap: 6px; align-items: center;">
          <!--a mat-icon-button [routerLink]="['/broker']" [queryParams]="{cuenta: nombre}"
             matTooltip="Ir a Cartera Broker" target="_blank" color="primary">
            <mat-icon>account_balance</mat-icon>
          </a-->
          <!--a mat-icon-button [routerLink]="['/confirmar']" [queryParams]="{idcartera: idcartera, cartera: nombre, modulo: 'broker', idcarterasuscrita: 0}" 
             matTooltip="Control operativa" target="_blank" color="accent">
            <mat-icon>list_alt</mat-icon>
          </a-->
        </div>
      </h5>

  <mat-card *ngIf="otraCuentaActiva" class="alert-card">
    <mat-card-content>
      <p>
        <mat-icon>warning</mat-icon>
        La cartera activa en el módulo Broker es otra. Posiciones sin actualizar{{ ultimaActualizacion ? ' desde las ' + (ultimaActualizacion | date:'HH:mm') : '' }}.
      </p>
    </mat-card-content>
  </mat-card>

  <div class="mt-wrapper mat-elevation-z8 ccorbit-mat-table" [style.height.px]="altoPosiciones">
    <div class="mt-scroll">
      <table class="mt-table tableStyle table-striped">
        <thead>
          <tr>
            <th *ngFor="let col of visibles.posiciones" class="sticky-header ordenable" [class.txt]="col.txt"
              (click)="orderByPosiciones(col.id)">
              {{col.nombre}}
              <mat-icon *ngIf="iconoOrden(sortPos, col.id) as icono" class="sort-icon">{{icono}}</mat-icon>
            </th>
            <th class="sticky-header col-x"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pos of posiciones; trackBy: trackPos" (click)="selectRow(pos)"
            (contextmenu)="selectRow(pos)" [cdkContextMenuTriggerFor]="context_menu"
            [class.selected]="esSeleccionada(pos)">
            <ng-container *ngFor="let col of visibles.posiciones" [ngSwitch]="col.id">
              <td *ngSwitchCase="'contractDesc'" class="txt"><mat-icon class="fila-icon">description</mat-icon>{{pos.contractDesc}}</td>
              <td *ngSwitchCase="'sl'" [class.celda-sl]="pos.slOrdenes?.length">
                <span *ngIf="pos.slOrdenes?.length > 1; else slUna" class="sl-tp-varias" [matTooltip]="pos.slTooltip">{{pos.slOrdenes.length}} órdenes</span>
                <ng-template #slUna>{{pos.sl | number:formatoPrecio(pos)}}</ng-template>
              </td>
              <td *ngSwitchCase="'tp'" [class.celda-tp]="pos.tpOrdenes?.length">
                <span *ngIf="pos.tpOrdenes?.length > 1; else tpUna" class="sl-tp-varias" [matTooltip]="pos.tpTooltip">{{pos.tpOrdenes.length}} órdenes</span>
                <ng-template #tpUna>{{pos.tp | number:formatoPrecio(pos)}}</ng-template>
              </td>
              <td *ngSwitchCase="'beneficio'" [class.numero-positivo]="pos.beneficio > 0" [class.numero-negativo]="pos.beneficio < 0">
                {{pos.beneficio | number:'1.2-2'}}
              </td>
              <ng-container *ngSwitchDefault>
                <td *ngIf="col.txt" class="txt">{{pos[col.id]}}</td>
                <td *ngIf="col.formato === 'precio'">{{pos[col.id] | number:formatoPrecio(pos)}}</td>
                <td *ngIf="col.formato === 'cantidad'">{{pos[col.id] | number:'1.0-4'}}</td>
                <td *ngIf="col.formato === 'importe'">{{pos[col.id] | number:'1.2-2'}}</td>
              </ng-container>
            </ng-container>
            <td class="col-x">
              <button class="btn-x" (click)="cerrarFila(pos, $event)" matTooltip="Cerrar posición">×</button>
            </td>
          </tr>
          <tr *ngIf="!posiciones.length"><td [attr.colspan]="visibles.posiciones.length + 1" class="txt vacio">Sin posiciones</td></tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
    (mousedown)="iniciarResize($event, 'posiciones')" (dblclick)="resetAlto('posiciones')"></div>
  <h5 class="sc-title">
    <span class="cartera-title-tag">
      <span class="cartera-title-tag__dot"></span>
      ÓRDENES: {{optimaWallet.nombre}}
    </span>
    <span class="conteo-tag" matTooltip="Órdenes listadas">{{ ordenes.length }}</span>
    <div style="display: flex; gap: 6px; align-items: center;">
      <button mat-icon-button class="filtro-icon" [class.active]="verAbiertos"
        (click)="toggleFiltroOrdenes('abiertos')" matTooltip="Pares abiertos">
        <mat-icon>lock_open</mat-icon>
      </button>
      <button mat-icon-button class="filtro-icon" [class.active]="verCerrados"
        (click)="toggleFiltroOrdenes('cerrados')" matTooltip="Pares cerrados">
        <mat-icon>lock</mat-icon>
      </button>
      <!--a mat-icon-button [routerLink]="['/broker']" [queryParams]="{cuenta: nombre}"
         matTooltip="Ir a Cartera Broker" target="_blank" color="primary">
        <mat-icon>account_balance</mat-icon>
      </a>
      <a mat-icon-button [routerLink]="['/broker-operations']" [queryParams]="{idcartera: idcartera, nombre: nombre}" 
         matTooltip="Ver Operaciones" target="_blank" color="accent">
        <mat-icon>list_alt</mat-icon>
      </a-->
    </div>
  </h5>

  <div class="mt-wrapper mat-elevation-z8 ccorbit-mat-table" [style.height.px]="altoOrdenes">
    <div class="mt-scroll">
      <table class="mt-table tableStyle table-striped">
        <thead>
          <tr>
            <th *ngFor="let col of visibles.ordenes" class="sticky-header ordenable" [class.txt]="col.txt"
              (click)="orderBy(col.id)">
              {{col.nombre}}
              <mat-icon *ngIf="iconoOrden(sortOrd, col.id) as icono" class="sort-icon">{{icono}}</mat-icon>
            </th>
            <th class="sticky-header col-x"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let orden of ordenes; trackBy: trackOrden" (click)="selectRow(orden)"
            (contextmenu)="selectRow(orden)" [cdkContextMenuTriggerFor]="context_menu2"
            [class.selected]="esSeleccionada(orden)">
            <ng-container *ngFor="let col of visibles.ordenes" [ngSwitch]="col.id">
              <td *ngSwitchCase="'ticker'" class="txt"><mat-icon class="fila-icon">schedule</mat-icon>{{orden.ticker}}</td>
              <td *ngSwitchCase="'tipoOperacion'" class="txt"
                [class.entrada]="orden.tipoOperacion?.startsWith('ENTRADA')" [class.salida]="orden.tipoOperacion?.startsWith('SALIDA')">{{orden.tipoOperacion}}</td>
              <td *ngSwitchCase="'status'" class="txt"
                [class.entrada]="orden.status === 'Filled'" [class.salida]="orden.status === 'PreSubmitted' || orden.status === 'Submitted'">{{orden.status}}</td>
              <td *ngSwitchCase="'modelo'" class="txt"><a *ngIf="orden.modelo" [href]="'/models?id=' + orden.modelo" target="_blank">{{orden.modelo}}</a></td>
              <ng-container *ngSwitchDefault>
                <td *ngIf="col.txt && col.formato !== 'fecha'" class="txt">{{orden[col.id]}}</td>
                <td *ngIf="col.formato === 'fecha'" class="txt">{{ (orden[col.id] && orden[col.id] !== '0') ? (orden[col.id] | date: 'dd-MM-yyyy HH:mm:ss') : '' }}</td>
                <td *ngIf="col.formato === 'precio'">{{orden[col.id] | number:formatoPrecio(orden)}}</td>
                <td *ngIf="col.formato === 'cantidad'">{{orden[col.id] | number:'1.0-4'}}</td>
              </ng-container>
            </ng-container>
            <td class="col-x">
              <button *ngIf="esOrdenCancelable(orden)" class="btn-x" (click)="cancelarFila(orden, $event)" matTooltip="Cancelar orden">×</button>
            </td>
          </tr>
          <tr *ngIf="!ordenes.length"><td [attr.colspan]="visibles.ordenes.length + 1" class="txt vacio">Sin órdenes</td></tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
    (mousedown)="iniciarResize($event, 'ordenes')" (dblclick)="resetAlto('ordenes')"></div>

  <ng-template #context_menu let-data="data">
    <div class="example-menu" cdkMenu [ngClass]="theme">
      <button class="example-menu-item" (click)="CerrarPosicion()" cdkMenuItem>
        <mat-icon class="menu-icon">close</mat-icon>
        <span>Cerrar</span>
      </button>
      <button class="example-menu-item" (click)="CerrarPosicionTodas()" cdkMenuItem>
        <mat-icon class="menu-icon">close</mat-icon>
        <span>Cerrar Todas las posiciones</span>
      </button>

    </div>
  </ng-template>

  <ng-template #context_menu2 let-data="data">
    <div class="example-menu" cdkMenu [ngClass]="theme">
      <button class="example-menu-item" (click)="CancelarOrden()" cdkMenuItem>
        <mat-icon class="menu-icon">cancel</mat-icon>
        <span>Cancelar Orden</span>
      </button>
      <button class="example-menu-item" (click)="CancelarTodasOrdenes()" [disabled]="cancelandoOrdenes" cdkMenuItem>
        <mat-icon class="menu-icon">cancel</mat-icon>
        <span>Cancelar todas las órdenes</span>
      </button>
    </div>

  </ng-template>
</div></body>